import parse from 'html-react-parser'
import { useIntl, defineMessages } from 'react-intl'
import type { FieldsConfiguration } from 'msp-components'
import { newsletterCheckboxLabel } from '@molecules/NewsletterForm/NewsletterForm.fields'

export const messages = defineMessages({
  salutation: {
    defaultMessage: 'Salutation',
    id: 'use_address_fields.label.salutation'
  },
  salutationMr: {
    defaultMessage: 'Mr',
    id: 'msp.label.salutation.mr'
  },
  salutationMrs: {
    defaultMessage: 'Mrs',
    id: 'msp.label.salutation.mrs'
  },
  firstName: {
    defaultMessage: 'First Name',
    id: 'use_address_fields.label.first_name'
  },
  email: {
    defaultMessage: 'Email address',
    id: 'msp.login_form.label.email'
  },
  lastName: {
    defaultMessage: 'Last Name',
    id: 'use_address_fields.label.last_name'
  },
  password: {
    defaultMessage: 'Password',
    id: 'msp.login_form.label.password'
  },
  repeatPassword: {
    defaultMessage: 'Repeat Password',
    id: 'msp.login_form.label.repeatPassword'
  },
  birthday: {
    defaultMessage: 'Date of birth (optional)',
    id: 'msp.login_form.label.birthday'
  },
  dataProtection: {
    defaultMessage:
      'Yes, I agree to the <a>terms and conditions</a> and the data protection regulations of Melitta Single Portions as well as a credit check.',
    id: 'msp.login_form.label.dataProtection'
  }
})

const getRegisterFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    salutation: {
      id: 'salutation',
      type: 'radio',
      name: 'salutation',
      placeholder: '',
      label: formatMessage(messages.salutation),
      options: [
        {
          id: 'mr',
          value: 'MR',
          label: formatMessage(messages.salutationMr),
          extraClassName: 'mr-2'
        },
        {
          id: 'mrs',
          value: 'MRS',
          label: formatMessage(messages.salutationMrs),
          extraClassName: 'ml-6 mr-2'
        }
      ],
      rules: {
        required: formatMessage({
          defaultMessage: 'Please select your salutation.',
          id: 'use_address_fields.error.please_select_salutation'
        })
      },
      defaultValues: 'MRS'
    },
    firstName: {
      id: 'firstName',
      type: 'text',
      name: 'firstName',
      placeholder: '',
      label: formatMessage(messages.firstName),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your first name.',
          id: 'use_address_fields.error.please_enter_first_name'
        })
      }
    },
    lastName: {
      id: 'lastName',
      type: 'text',
      name: 'lastName',
      placeholder: '',
      label: formatMessage(messages.lastName),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your last name.',
          id: 'use_address_fields.error.please_enter_last_name'
        })
      }
    },
    email: {
      id: 'email',
      type: 'email',
      name: 'email',
      placeholder: '',
      label: formatMessage(messages.email),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your email address.',
          id: 'msp.login_form.error.required_email'
        }),
        pattern: {
          value: new RegExp(
            '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
            'i'
          ),
          message: formatMessage({
            defaultMessage: 'Please enter valid email address.',
            id: 'msp.login_form.error.valid_email'
          })
        }
      }
    },
    password: {
      id: 'password',
      type: 'password',
      name: 'password',
      placeholder: '',
      label: formatMessage(messages.password),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your password.',
          id: 'msp.login_form.error.required_password'
        })
      }
    },
    repeatPassword: {
      id: 'repeatPassword',
      type: 'password',
      name: 'repeatPassword',
      placeholder: '',
      label: formatMessage(messages.repeatPassword),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your password.',
          id: 'msp.login_form.error.required_password'
        })
      }
    },
    birthday: {
      id: 'birthday',
      type: 'date',
      name: 'birthday',
      placeholder: 'dd/mm/yyyy',
      label: formatMessage(messages.birthday)
    },
    newsletter: {
      id: 'newsletter',
      type: 'checkbox',
      name: 'newsletter',
      placeholder: '',
      label: newsletterCheckboxLabel()
    },
    dataProtection: {
      id: 'dataProtection',
      type: 'checkbox',
      name: 'dataProtection',
      placeholder: '',
      label: formatMessage(messages.dataProtection, {
        a: (link: string) =>
          parse(
            `<a className='underline underline-offset-2' href='conditions'>${link}</a>`
          )
      }),
      rules: {
        required: formatMessage({
          defaultMessage:
            'Please check data protection before sending the form.',
          id: 'msp.login_form.error.dataProtection'
        })
      }
    }
  }
}

export default getRegisterFields
